import { isValidSafeNSName } from "./safens.mjs";
//#region src/utils/named-packages.ts
/** The pattern to find an optionally versioned name */
const NAME_PATTERN = /^([a-z0-9]+(?:-[a-z0-9]+)*)$/;
/** The pattern for a valid version number */
const VERSION_REGEX = /^\d+$/;
/** The maximum size for an app */
const MAX_APP_SIZE = 64;
const isValidNamedPackage = (name) => {
	const parts = name.split("/");
	if (parts.length < 2 || parts.length > 3) return false;
	const [org, app, version] = parts;
	if (version !== void 0 && !VERSION_REGEX.test(version)) return false;
	if (!isValidSafeNSName(org)) return false;
	return NAME_PATTERN.test(app) && app.length < MAX_APP_SIZE;
};
//#endregion
export { isValidNamedPackage };

//# sourceMappingURL=named-packages.mjs.map